<template>
    <div class="base_box">
        <baseSearch @search="searchFun" :list="searchFrom" :searchData="search.post">
            <template #btns="scope">
                <el-button type="primary" class="btnsty base_but_style base_search_create" @click="addFun">+添加报名</el-button>
                <el-button type="success" size="small" @click="batchPass">批量审核</el-button>
                <el-button type="danger" size="small" @click="batchEliminate">批量淘汰</el-button>
                <el-button type="danger" size="small" @click="batchReject">批量驳回</el-button>
            </template>
        </baseSearch>
        
        <!-- 状态标签 -->
        <div class="status-tabs">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane label="待审核" name="0"></el-tab-pane>
                <el-tab-pane label="通过" name="1"></el-tab-pane>
                <el-tab-pane label="淘汰" name="2"></el-tab-pane>
                <el-tab-pane label="驳回" name="4"></el-tab-pane>
                <el-tab-pane label="晋级" name="3"></el-tab-pane>
                
                
            </el-tabs>
        </div>

        <div class="mt10 base_content">
            <baseTable ref="table" :loading="search.loading" :total="search.total" :page="search.post.page" :list="search.table"
                :tableList="search.tableForm" :pagesize="search.post.limit" @changePage="handlePageChange"
                selection @tableSelectionChange="handleSelectionChange">
                <template #competition="scope">
                    <div class="multi-line-ellipsis" @mouseenter="showTip($event, scope.row.competition?.title || '-')" @mouseleave="hideTip">
                        {{ scope.row.competition?.title || '-' }}
                    </div>
                </template>
                <template #nickname="scope">
                    <div class="multi-line-ellipsis" @mouseenter="showTip($event, (scope.row.nickname || '') + '\n身份证号：' + (scope.row.id_card || '-') + '\n手机号：' + (scope.row.mobile || '-'))" @mouseleave="hideTip">
                        <div>{{ scope.row.nickname || '-' }}</div>
                        <div style="font-size: 12px; color: #999;">身份证号：{{ scope.row.id_card || '-' }}</div>
                        <div style="font-size: 12px; color: #999;">手机号：{{ scope.row.mobile || '-' }}</div>
                    </div>
                </template>
                <template #show_image="scope">
                    <el-image 
                        style="width: 40px; height: 40px"
                        :src="typeof scope.row.show_image === 'object' ? scope.row.show_image.url : (scope.row.show_image || '')" 
                        :preview-src-list="[typeof scope.row.show_image === 'object' ? scope.row.show_image.url : (scope.row.show_image || '')]">
                    </el-image>
                </template>
                <template #show_video="scope">
                    <span v-if="scope.row.show_video" class="video-link" @click="playVideo(scope.row)">点击播放</span>
                    <span v-else>-</span>
                </template>
                <template #intro="scope">
                    <div class="multi-line-ellipsis" @mouseenter="showTip($event, scope.row.intro || '-')" @mouseleave="hideTip">
                        {{ scope.row.intro || '-' }}
                    </div>
                </template>
                <template #sign_status="scope">
                    <span :class="getStatusClass(scope.row.sign_status)">
                        {{ getStatusText(scope.row.sign_status) }}
                    </span>
                </template>
                <template #sign_type="scope">
                    <span>{{ scope.row.sign_type == 0 ? '自主报名' : '后台报名' }}</span>
                </template>
                <template #material_qrcode_id="scope">
                    <el-image 
                        style="width: 60px; height: 60px"
                        :src="typeof scope.row.material_qrcode_id === 'object' ? scope.row.material_qrcode_id.url : (scope.row.material_qrcode_id || '')" 
                        :preview-src-list="[typeof scope.row.material_qrcode_id === 'object' ? scope.row.material_qrcode_id.url : (scope.row.material_qrcode_id || '')]">
                    </el-image>
                </template>
                <template #operation="scope">
                    <!-- 待审核：只显示通过和驳回 -->
                    <template v-if="scope.row.sign_status === 0">
                        <el-button type="text" @click="passFun(scope.row)">通过</el-button>
                        <el-button type="text" @click="rejectFun(scope.row)">驳回</el-button>
                    </template>
                    <!-- 通过：显示淘汰和活动记录 -->
                    <template v-else-if="scope.row.sign_status === 1">
                        <el-button type="text" @click="eliminateFun(scope.row)">淘汰</el-button>
                        <el-button type="text" @click="recordFun(scope.row)">活动记录</el-button>
                    </template>
                    <!-- 淘汰：只显示恢复 -->
                    <template v-else-if="scope.row.sign_status === 2">
                        <el-button type="text" @click="recoverFun(scope.row)">恢复</el-button>
                    </template>
                    <!-- 驳回：不显示任何操作 -->
                    <template v-else-if="scope.row.sign_status === 4">
                    </template>
                </template>
            </baseTable>
        </div>

        <!-- 视频播放弹窗 -->
        <el-dialog title="视频播放" :visible.sync="videoPlayDialog.visible" width="600px" append-to-body>
            <div style="text-align: center;">
                <video :src="videoPlayDialog.url" controls style="max-width: 100%; max-height: 500px;"></video>
            </div>
        </el-dialog>

        <!-- 添加选手弹窗 -->
        <el-dialog title="添加选手" :visible.sync="dialogShow" width="600px">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="报名活动：">
                    <el-select v-model="form.competition_id" placeholder="请输入活动名称搜索" filterable remote :remote-method="searchCompetitions">
                        <el-option v-for="item in competitions" :key="item.id" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="搜索用户：">
                    <el-select v-model="form.user_id" placeholder="请输入用户名或手机号搜索" filterable remote :remote-method="searchUsers" :loading="usersLoading">
                        <el-option v-for="item in users" :key="item.user_id" :label="item.nick_name + ' ' + item.mobile" :value="item.user_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选手姓名：">
                    <el-input v-model="form.nickname" placeholder="请输入选手姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：">
                    <el-input v-model="form.id_card" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="选手封面：">
                    <div class="goodsimage">
                        <div class="imgbox" @click="openImgPlugin('image')">
                            <el-image v-if="form.show_image" :src="typeof form.show_image === 'object' ? form.show_image.url : form.show_image" fit="cover"></el-image>
                            <i v-if="!form.show_image" class="el-icon-plus addicon"></i>
                            <div v-if="!form.show_image" class="text">添加图片</div>
                        </div>
                        <span class="img-tip">建议尺寸：750 像素*750 像素</span>
                    </div>
                </el-form-item>
                <el-form-item label="选手视频：" v-if="currentCompetitionApplyType === 2">
                    <div class="goodsimage">
                        <div class="imgbox video-box" @click="selectVideo">
                            <template v-if="form.show_video">
                                <el-image v-if="form.show_video_cover" :src="form.show_video_cover" fit="cover"></el-image>
                                <div v-else class="video-icon">
                                    <i class="el-icon-video-play"></i>
                                </div>
                                <div class="video-filename">{{ form.show_video.name }}</div>
                            </template>
                            <template v-else>
                                <i class="el-icon-plus addicon"></i>
                                <div class="text">添加视频</div>
                            </template>
                        </div>
                        <span class="img-tip">建议上传横版尺寸且大小不要超过 50M 的视频</span>
                    </div>
                    <input type="file" ref="videoFile" style="display: none;" accept="video/*" @change="handleVideoUpload">
                </el-form-item>
                <el-form-item label="选手简介：">
                    <el-input type="textarea" v-model="form.intro" placeholder="请输入选手简介"></el-input>
                </el-form-item>
                <el-form-item label="审核状态：">
                    <el-radio-group v-model="form.sign_status">
                        <el-radio :label="1">通过</el-radio>
                        <el-radio :label="0">待审核</el-radio>
                        <el-radio :label="4">驳回</el-radio>
                        <el-radio :label="2">淘汰</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排名：" v-if="form.sign_status === 2 || form.sign_status === 4">
                    <el-input-number v-model="form.sort" :min="0" placeholder="请输入排名"></el-input-number>
                </el-form-item>
                <el-form-item label="备注：" v-if="form.sign_status === 2 || form.sign_status === 4">
                    <el-input type="textarea" v-model="form.reject_remark" placeholder="请输入驳回/淘汰备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">取消</el-button>
                <el-button type="primary" @click="submitFun">确认</el-button>
            </div>
        </el-dialog>

        <!-- 驳回/淘汰弹窗 -->
        <el-dialog :title="currentAction === 'reject' ? '驳回选手' : '淘汰选手'" :visible.sync="rejectDialogShow" width="400px">
            <el-form ref="rejectForm" :model="rejectForm" label-width="80px">
                <el-form-item label="原因：">
                    <el-input type="textarea" v-model="rejectForm.reject_remark" :placeholder="currentAction === 'reject' ? '请输入驳回原因' : '请输入淘汰原因'"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogShow = false">取消</el-button>
                <el-button type="primary" @click="selectedRows.length > 0 ? confirmBatchAction() : (currentAction === 'reject' ? confirmReject() : confirmEliminate())">确认</el-button>
            </div>
        </el-dialog>

        <!-- 图片选择器 -->
        <xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple"
            :count="imgplugin.count" is_rest>
        </xsk-manage>

        <!-- 通用提示弹窗 -->
        <div v-if="tip.visible" class="tip-box" :style="{ left: tip.x + 'px', top: tip.y + 'px' }">
            {{ tip.text }}
        </div>
    </div>
</template>

<script>
import baseSearch from "@/components/common/baseSearch.vue"
import baseTable from "@/components/common/baseTable.vue"

export default {
    name: 'SignList',
    components: {
        baseSearch,
        baseTable
    },
    data() {
            return {
                dialogShow: false,
                rejectDialogShow: false,
                rejectForm: {
                    reject_remark: ''
                },
                currentRow: {},
                currentAction: 'reject',
                activeTab: 'all',
                selectedRows: [],
                competitions: [],
                users: [],
                usersLoading: false,
                currentCompetitionApplyType: 1,
                // 通用提示弹窗
                tip: {
                    visible: false,
                    text: '',
                    x: 0,
                    y: 0
                },
            form: {
                competition_id: '',
                user_id: '',
                nickname: '',
                intro: '',
                id_card: '',
                show_type: 1,
                show_image: '',
                show_video: '',
                show_video_cover: '',
                sign_status: 1,
                reject_remark: '',
                sort: 0
            },
            imgplugin: {
                show: false,
                multiple: false,
                count: 1,
                imgName: '',
                type: ''
            },
            settingInfo: {},
            // 视频播放弹窗
            videoPlayDialog: {
                visible: false,
                url: ''
            },
            search: {
                loading: false,
                total: 0,
                post: {
                    page: 1,
                    limit: 10,
                    competition_id: 0,
                    sign_status: '',
                    stage: '',
                    sign_type: ''
                },
                table: [],
                tableForm: [
                    { prop: 'id', label: '编号', width: 100 },
                    // { prop: 'sort', label: '赛事排名' },
                    { prop: 'competition', label: '活动名称', width: 220 },
                    { prop: 'nickname', label: '选手信息', width: 200 },
                    { prop: 'intro', label: '选手介绍', width: 260 },
                    { prop: 'show_image', label: '选手图片', width: 100 },
                    { prop: 'show_video', label: '选手视频', width: 100 },
                    { prop: 'vote_num', label: '票数', width: 100 },
                    { prop: 'material_qrcode_id', label: '小程序码', width: 120 },
                    { prop: 'sign_status', label: '状态', width: 80 },
                    { prop: 'sign_type', label: '报名类型', width: 100 },
                    { prop: 'created_at', label: '创建时间', width: 160 },
                    { prop: 'operation', label: '操作', width: 120 }
                ]
            },
            searchFrom: [
                { 
                    type: 'input', 
                    Field: 'competition_title', 
                    label: '活动名称', 
                    placeholder: '请输入活动名称',
                    style: { width: '200px' }
                },
                { 
                    type: 'input', 
                    Field: 'nickname', 
                    label: '选手信息', 
                    placeholder: '选手姓名/手机号码',
                    style: { width: '200px' }
                },
                { 
                    type: 'input', 
                    Field: 'intro', 
                    label: '作品名称', 
                    placeholder: '请输入作品名称',
                    style: { width: '200px' }
                },
                // { 
                //     type: 'select', 
                //     Field: 'sign_status', 
                //     label: '状态', 
                //     placeholder: '全部',
                //     style: { width: '150px' },
                //     options: [
                //         { label: '全部', value: -1 },
                //         { label: '待审核', value: 0 },
                //         { label: '通过', value: 1 },
                //         { label: '淘汰', value: 2 },
                //         { label: '晋级', value: 3 },
                //         { label: '驳回', value: 4 }
                //     ]
                // },
                { 
                    type: 'select', 
                    Field: 'sign_type', 
                    label: '报名类型', 
                    placeholder: '全部',
                    style: { width: '150px' },
                    options: [
                        { label: '全部', value: -1 },
                        { label: '自主报名', value: 0 },
                        { label: '后台报名', value: 1 }
                    ]
                }
            ]
        }
    },
    watch: {
        'form.competition_id'(newVal) {
            if (newVal) {
                const competition = this.competitions.find(item => item.id === parseInt(newVal))
                if (competition) {
                    this.currentCompetitionApplyType = competition.apply_type || 1
                } else {
                    this.currentCompetitionApplyType = 1
                }
            } else {
                this.currentCompetitionApplyType = 1
            }
        }
    },
    created() {
        // 从URL参数获取活动ID
        const competitionId = this.$route.query.competition_id
        if (competitionId) {
            this.search.post.competition_id = parseInt(competitionId)
        }
        this.searchFun()
        this.loadCompetitions()
        this.loadUsers()
        this.getInfo()
    },
    methods: {
        showTip(event, text) {
            if (!text) return
            this.tip.text = text
            this.tip.x = event.clientX + 10
            this.tip.y = event.clientY + 10
            this.tip.visible = true
        },
        hideTip() {
            this.tip.visible = false
        },
        getStatusText(status) {
            const statusMap = {
                0: '待审核',
                1: '通过',
                2: '淘汰',
                3: '晋级',
                4: '驳回'
            }
            return statusMap[status] || '-'
        },
        getStatusClass(status) {
            const classMap = {
                0: 'status-pending',
                1: 'status-pass',
                2: 'status-eliminate',
                3: 'status-promote',
                4: 'status-reject'
            }
            return classMap[status] || 'status-default'
        },
        searchFun(searchData) {
            const _this = this
            // 如果有传递搜索数据，则更新到搜索参数
            if (searchData) {
                Object.assign(_this.search.post, searchData)
                // 重置页码为1
                _this.search.post.page = 1
            }
            _this.search.loading = true
            let params = { ...this.search.post }
            // 根据标签页设置状态
            if (this.activeTab !== 'all') {
                params.sign_status = parseInt(this.activeTab)
            }
            _this.axios.get('/api/sing/admin/sign/list', { params }).then(res => {
                _this.search.loading = false
                if (res.code == 200) {
                    _this.search.table = res.data.data
                    _this.search.total = res.data.total
                }
            }).catch(() => {
                _this.search.loading = false
            })
        },
        handlePageChange(page) {
            this.search.post.page = page
            this.searchFun()
        },
        handleTabClick(tab) {
            this.activeTab = tab.name
            this.searchFun()
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },
        batchEliminate() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择要淘汰的选手')
                return
            }
            this.currentAction = 'eliminate'
            this.rejectForm = { reject_remark: '' }
            this.rejectDialogShow = true
        },
        batchReject() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择要驳回的选手')
                return
            }
            this.currentAction = 'reject'
            this.rejectForm = { reject_remark: '' }
            this.rejectDialogShow = true
        },
        batchPass() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择要审核的选手')
                return
            }
            const ids = this.selectedRows.map(row => row.id)
            this.axios.post('/api/sing/admin/sign/audit', {
                sign_status: 1,
                ids: ids
            }).then(res => {
                if (res.code == 200) {
                    this.$message.success('操作成功')
                    this.searchFun()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                this.$message.error('操作失败')
            })
        },
        confirmBatchAction() {
            const _this = this
            const ids = this.selectedRows.map(row => row.id)
            let status, reject_remark
            
            if (_this.currentAction === 'pass') {
                status = 1
                reject_remark = ''
            } else if (_this.currentAction === 'reject') {
                status = 4
                reject_remark = _this.rejectForm.reject_remark
            } else {
                status = 2
                reject_remark = _this.rejectForm.reject_remark
            }
            
            _this.axios.post('/api/sing/admin/sign/audit', {
                sign_status: status,
                reject_remark: reject_remark,
                ids: ids
            }).then(res => {
                if (res.code == 200) {
                    _this.$message.success('操作成功')
                    _this.rejectDialogShow = false
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        },
        loadCompetitions() {
            this.axios.get('/api/sing/admin/competition/list', { params: { status: 1, page: 1, limit: 100 } }).then(res => {
                if (res.code == 200) {
                    this.competitions = res.data.data || []
                }
            })
        },
        searchCompetitions(query) {
            if (!query || query.trim() === '') {
                this.loadCompetitions()
                return
            }
            this.axios.get('/api/sing/admin/competition/list', { params: { status: 1, page: 1, limit: 50, title: query.trim() } }).then(res => {
                if (res.code == 200) {
                    this.competitions = res.data.data || []
                }
            })
        },
        loadUsers() {
            this.axios.get('/api/weishop/admin/user/list', { params: { page: 1, limit: 100 } }).then(res => {
                if (res.code == 200) {
                    console.log(320,res);
                    this.users = res.data.list.data || []
                }
            })
        },
        searchUsers(query) {
            if (!query || query.trim() === '') {
                this.loadUsers()
                return
            }
            this.usersLoading = true
            this.users = []
            this.axios.get('/api/weishop/admin/user/list', { params: { page: 1, limit: 50, keyword: query.trim() } }).then(res => {
                if (res.code == 200) {
                    this.users = res.data.list.data || []
                }
            }).finally(() => {
                this.usersLoading = false
            })
        },
        addFun() {
            this.form = {
                competition_id: '',
                user_id: '',
                nickname: '',
                intro: '',
                id_card: '',
                show_type: 1,
                show_image: '',
                show_video: '',
                show_video_cover: '',
                sign_status: 1,
                reject_remark: '',
                sort: 0
            }
            this.dialogShow = true
        },
        // 获取系统设置
        getInfo() {
            let _this = this
            _this.axios.get('/api/common/shop/admin/upload/setting/index').then((res) => {
                if (res.code == 200) {
                    if (res.data) {
                        _this.settingInfo = res.data
                    }
                }
            })
        },
        selectVideo() {
            this.$refs.videoFile.click()
        },
        handleVideoUpload(event) {
            const _this = this
            const file = event.target.files[0]
            if (!file) return
            
            // 检查系统设置
            if (!_this.settingInfo || !_this.settingInfo.storage_type) {
                _this.$message.error('系统设置未加载，请刷新页面重试')
                return
            }
            
            // 显示加载状态
            this.$loading({
                lock: true,
                text: '视频上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            // 生成文件名
            const date = new Date()
            const Y = date.getFullYear()
            const M = String(date.getMonth() + 1).padStart(2, '0')
            const D = String(date.getDate()).padStart(2, '0')
            const h = String(date.getHours()).padStart(2, '0')
            const m = String(date.getMinutes()).padStart(2, '0')
            const s = String(date.getSeconds()).padStart(2, '0')
            const tempFormat = file.name.substring(file.name.lastIndexOf(".") + 1)
            const filePath = "upload/video/" + Y + M + D + "/" + Y + M + D + h + m + s + "." + tempFormat
            
            try {
                // 阿里云OSS上传
                const OSS = require('ali-oss')
                const client = new OSS({
                    region: _this.settingInfo.region.split(".")[0],
                    accessKeyId: _this.settingInfo.access_key,
                    accessKeySecret: _this.settingInfo.secret_key,
                    bucket: _this.settingInfo.bucket,
                })
                
                // 先上传到阿里云OSS
                client.put(filePath, file).then((result) => {
                    console.log('OSS上传成功:', result)
                    // 再调用后端接口记录
                    return _this.axios.post("/api/common/upload-video", {
                        file_hash: filePath,
                        file_key: filePath,
                        origin_name: file.name,
                    })
                }).then((resd) => {
                    console.log('后端接口返回:', resd)
                    console.log('后端返回的cover_url:', resd.data?.cover_url)
                    console.log('后端返回的cover:', resd.data?.cover)
                    if (resd.code == 200) {
                        _this.form.show_video = {
                            id: resd.data.id,
                            url: resd.data.url,
                            name: file.name
                        }
                        // 如果后端返回了封面URL则使用，否则留空显示默认视频图标
                        const coverUrl = resd.data.cover_url || resd.data.cover || ''
                        console.log('最终使用的封面URL:', coverUrl)
                        _this.form.show_video_cover = coverUrl
                        _this.$message.success('视频上传成功')
                    } else {
                        _this.$message.error(resd.msg || '视频上传失败')
                    }
                }).catch((err) => {
                    console.error('视频上传失败:', err)
                    _this.$message.error('视频上传失败: ' + (err.message || '未知错误'))
                }).finally(() => {
                    _this.$loading().close()
                })
            } catch (e) {
                console.error('初始化OSS客户端失败:', e)
                _this.$message.error('视频上传失败: ' + e.message)
                _this.$loading().close()
            }
        },
        passFun(row) {
            const _this = this
            _this.axios.post(`/api/sing/admin/sign/audit/${row.id}`, { sign_status: 1 }).then(res => {
                if (res.code == 200) {
                    _this.$message.success('操作成功')
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        },
        rejectFun(row) {
            this.currentRow = row
            this.rejectForm = { reject_remark: '' }
            this.rejectDialogShow = true
        },
        confirmReject() {
            const _this = this
            _this.axios.post(`/api/sing/admin/sign/audit/${_this.currentRow.id}`, { 
                sign_status: 4,
                reject_remark: _this.rejectForm.reject_remark
            }).then(res => {
                if (res.code == 200) {
                    _this.$message.success('操作成功')
                    _this.rejectDialogShow = false
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        },
        eliminateFun(row) {
            this.currentRow = row
            this.rejectForm = { reject_remark: '' }
            this.rejectDialogShow = true
            this.currentAction = 'eliminate'
        },
        recoverFun(row) {
            const _this = this
            _this.axios.post(`/api/sing/admin/sign/audit/${row.id}`, { sign_status: 1 }).then(res => {
                if (res.code == 200) {
                    _this.$message.success('恢复成功')
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        },
        confirmEliminate() {
            const _this = this
            _this.axios.post(`/api/sing/admin/sign/audit/${_this.currentRow.id}`, { 
                sign_status: 2,
                reject_remark: _this.rejectForm.reject_remark
            }).then(res => {
                if (res.code == 200) {
                    _this.$message.success('操作成功')
                    _this.rejectDialogShow = false
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        },
        playVideo(row) {
            if (row.show_video) {
                const videoUrl = typeof row.show_video === 'object' ? row.show_video.url : row.show_video
                console.log('视频URL:', videoUrl)
                console.log('show_video数据:', row.show_video)
                if (videoUrl) {
                    this.videoPlayDialog.url = videoUrl
                    this.videoPlayDialog.visible = true
                }
            }
        },
        recordFun(row) {
            this.$router.push(`/application/competition/vote/${row.competition_id}`)
        },
        openImgPlugin(type) {
            this.imgplugin.show = true
            this.imgplugin.imgName = 'sign'
            this.imgplugin.type = type
        },
        imgpluginFun(obj) {
            if (obj && obj.imgobjs && obj.imgobjs.length > 0) {
                if (this.imgplugin.type === 'image') {
                    this.form.show_image = {
                        id: obj.imgobjs[0].id,
                        url: obj.imgobjs[0].url || obj.imgobjs[0].path || obj.imgobjs[0].src
                    }
                } else {
                    this.form.show_video = {
                        id: obj.imgobjs[0].id,
                        url: obj.imgobjs[0].url || obj.imgobjs[0].path || obj.imgobjs[0].src
                    }
                }
            }
        },
        submitFun() {
            const _this = this
            // 严格检查 competition_id
            const competitionId = parseInt(_this.form.competition_id)
            if (!competitionId || competitionId <= 0) {
                _this.$message.error('请选择活动')
                return
            }
            // 严格检查 user_id
            const userId = parseInt(_this.form.user_id)
            if (!userId || userId <= 0) {
                _this.$message.error('请选择用户')
                return
            }
            if (!_this.form.nickname || _this.form.nickname.trim() === '') {
                _this.$message.error('请输入选手姓名')
                return
            }
            if (!_this.form.show_image) {
                _this.$message.error('请上传选手封面')
                return
            }
            // 根据活动类型判断是否需要视频
            if (this.currentCompetitionApplyType === 2 && (!_this.form.show_video || !_this.form.show_video.id)) {
                _this.$message.error('请上传选手视频')
                return
            }
            let data = {
                competition_id: competitionId,
                user_id: userId,
                nickname: _this.form.nickname.trim(),
                intro: _this.form.intro || '',
                show_type: this.currentCompetitionApplyType,
                show_image: typeof _this.form.show_image === 'object' ? _this.form.show_image.id : _this.form.show_image,
                sign_status: _this.form.sign_status || 1,
                sort: _this.form.sort || 0
            }
            // 身份证号选填
            if (_this.form.id_card) {
                data.id_card = _this.form.id_card
            }
            // 视频 ID（当活动类型为视频投票时）
            if (_this.form.show_video && typeof _this.form.show_video === 'object' && _this.form.show_video.id) {
                data.show_video = _this.form.show_video.id
            }
            // 驳回/淘汰备注
            if (_this.form.sign_status === 2 || _this.form.sign_status === 4) {
                data.reject_remark = _this.form.reject_remark || ''
            }
            // 提交数据（视频已提前上传）
            _this.axios.post('/api/sing/admin/sign/add', data).then(res => {
                if (res.code == 200) {
                    _this.$message.success('添加成功')
                    _this.dialogShow = false
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        }
    }
}
</script>

<style scoped>
.status-tabs {
    margin-bottom: 10px;
}

.status-pending {
    color: #e6a23c;
}
.status-pass {
    color: #67c23a;
}
.status-eliminate {
    color: #f56c6c;
}
.status-promote {
    color: #409eff;
}
.status-reject {
    color: #909399;
}
.video-link {
    color: #409eff;
    cursor: pointer;
}
.goodsimage {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.imgbox {
    width: 100px;
    height: 100px;
    border: 1px dashed #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 10px;
    position: relative;
}
.imgbox img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.addicon {
    font-size: 24px;
    color: #ccc;
}
.text {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
}
.img-tip {
    font-size: 12px;
    color: #999;
    margin-left: 10px;
}
.video-box {
    position: relative;
}
.video-icon {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    background: #f5f7fa;
}
.video-icon i {
    font-size: 32px;
}
.video-filename {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 4px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.batch-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 10px;
}
.batch-toolbar span {
    margin-right: 10px;
    font-weight: bold;
}
.intro-tooltip {
    cursor: pointer;
}
.intro-tip-box {
    position: fixed;
    max-width: 300px;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    z-index: 9999;
    word-break: break-word;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}
/* 多行省略样式 */
.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    line-height: 1.5;
    word-break: break-all;
}
/* 通用提示弹窗样式 */
.tip-box {
    position: fixed;
    max-width: 350px;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    z-index: 9999;
    word-break: break-word;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    white-space: pre-wrap;
}
</style>